import { useInfiniteQuery } from '@tanstack/react-query';

import {
  formatInfiniteData,
  getNextPageParam,
} from 'components/helpers/reactQuery';

export function useInfiniteProjectsTeamSearchesQuery({
  params,
  projectId,
  queryOptions,
}) {
  return useInfiniteQuery({
    queryKey: ['projects', projectId, 'teamSearches', params],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await axios.post(
        `/projects/${projectId}/team_searches`,
        { team_search: { ...params, page: pageParam } },
      );

      return response.data;
    },
    getNextPageParam,
    select: (data) => formatInfiniteData({ data }),
    ...queryOptions,
  });
}
